import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoLocationTag } from '../../../../state/tags/definitions/geo/location';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoLocationTagItemProps {
  tag: IGeoLocationTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoLocationTagItem = (props: IGeoLocationTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
